import LogProcess from "../../../components/StructuredLog/LogProcess";

// Function to validate audio content using AudioContext and FileReader
const validateAudio = async (audioBlob) => {
    
    await LogProcess("success", "Starting at method validateAudio");

    console.dir(audioBlob, { depth: null });
    console.info(audioBlob);

    const context = new (window.AudioContext || window.webkitAudioContext)();
    const reader = new FileReader();
  

    // First check if audioBlob exists and is not null
    if (!audioBlob || audioBlob.size === 0) {
        await LogProcess("error", "At method validateAudio: AudioBlob is missing or empty.");
        return false;
    }
  
    // Validate audio size (should not be bigger than 1.9MB)
    const audioSizeMb = audioBlob.size / (1024 * 1024);
    if (audioSizeMb > 1.9) {      
         await LogProcess("warn", `At method validateAudio: Audio size is ${audioSizeMb.toFixed(2)} MB, which is bigger than the limit of 1.9MB.`);
         return false;
    }

    // Log success if audio size is valid
    await LogProcess("success", `At method validateAudio: Audio size is valid (${audioSizeMb.toFixed(2)} MB).`);

    // Wrap in a promise to make it awaitable
    try {
        // Convert Blob to ArrayBuffer
        const arrayBuffer = await new Promise((resolve, reject) => {
            reader.onload = () => resolve(reader.result);
            reader.onerror = async () => {
                await LogProcess("error", `FileReader encountered an error: ${reader.error}`);
                reject(reader.error);
            };
            reader.readAsArrayBuffer(audioBlob);
        });
  
        // Decode audio data
        const audioBuffer = await context.decodeAudioData(arrayBuffer);
  
        if (!audioBuffer || !audioBuffer.length) {
            // Check if audio buffer is valid
            await LogProcess("error", `At method validateAudio: Audio buffer is invalid or empty.`);
            return false;
        }
  
        const channelData = audioBuffer.getChannelData(0); // Get audio channel data
        const nonSilenceThreshold = 0.01; // Threshold to check for silence
        const hasSound = channelData.some((sample) => Math.abs(sample) > nonSilenceThreshold);
  
        if (!hasSound) {
            // If no sound is detected
            await LogProcess("warn", "At method validateAudio: Audio content is silent.");
            return false;
        }
  
        // Calculate duration of audio using sample rate and buffer length
        const audioDuration = audioBuffer.duration;
        if (audioDuration > 15) {
            // Ensure the audio doesn't exceed 15 seconds
            await LogProcess("warn", `At method validateAudio: Audio duration is ${audioDuration.toFixed(2)} seconds, which exceeds the 15-second limit.`);
            return false;
        }

        // If all checks pass, log success and return true
        await LogProcess("success", `At method validateAudio: Audio is valid with duration of ${audioDuration.toFixed(2)} seconds and size of ${audioSizeMb.toFixed(2)} MB.`);
        return true;
  
    } catch (error) {
        // Catch and log any errors in the decoding or reading process
        await LogProcess("error", `At method validateAudio: Error during audio validation: ${error}`);
        return false;
    }
};

export default validateAudio;